/* eslint-disable linebreak-style */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges
} from '@angular/core';
import { AmiTableTemplate } from 'src/app/@amiga-pyme/templates/ami-table.template';
import { IAction, IEventAction } from './ami-table-actions.interface';

@Component({
  selector: 'ami-table-actions',
  templateUrl: './ami-table-actions.component.html',
  styleUrls: ['./ami-table-actions.component.scss']
})
export class AmiTableActionsComponent extends AmiTableTemplate {
  @Input() actions: IAction[];
  @Output() action = new EventEmitter<IEventAction>();
  @Input() actionsHead: IAction[];
  @Input() showSearchHelpers = true;
  @Input() useVisible = false;

  totalRecords = 0;
  rows = 10;


  ngOnChanges(changes: SimpleChanges) {
    const settings = this.settings;
    this._selectedColumns = settings.columns;
    const changesData = changes?.data.currentValue;
    if (changesData) {
      this.listingData = false;
      this.data = changesData;
    }
  }

  transformDateInput(eventValue: string, header: string): string {
    if (!header.includes('Fecha') || eventValue.length < 1) return eventValue;
    let newDateString: string;

    if (eventValue.length == 1) {
      newDateString = `-${eventValue}`;
      return newDateString;
    }
    if (eventValue.length < 4) {
      const [day] = eventValue.split('/');
      newDateString = `-${day.padStart(2, '0')}`;
      return newDateString;
    }

    if (eventValue.length == 4) {
      const [day, month] = eventValue.split('/');
      newDateString = `${month}0-${day.padStart(2, '0')}`;
      return newDateString;
    }

    if (eventValue.length < 7 && eventValue.length > 3) {
      const [day, month] = eventValue.split('/');

      newDateString = `-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      return newDateString;
    }

    if (eventValue.length == 7) {
      const [day, month, year] = eventValue.split('/');
      if (year.length > 1) {
        newDateString = `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )}`;
        return newDateString;
      }
      newDateString = `${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

      return newDateString;
    }

    if (eventValue.length > 6) {
      const [day, month, year] = eventValue.split('/');
      newDateString = `${year}-${month.padStart(2, '0')}-${day.padStart(
        2,
        '0'
      )}`;
      return newDateString;
    }

    return eventValue;
  }

  actionRow(action: any, rowData: unknown) {
    this.action.emit({ action: action?.name, data: rowData });
  }
  actionHeadRow(action: any) {
    this.action.emit({ action: action?.name, data: null });
  }


  isNegativeSaldo(colField: string, value: number): boolean {
    const saldoFields = [
      'cantidad_saldo',
      'costo_unitario_saldo',
      'costo_total_saldo'
    ];

    return saldoFields.includes(colField) && value < 0;
  }

  onLazyLoad(event: any) {
    if (!this.isServerSide) return;

    const page = event.first / event.rows + 1;

    this.action.emit({  
      action: 'paginate',
      data: {
        page,
        limit: event.rows
      }
    });
  }



  get isServerSide(): boolean {
    return !!this.settings?.serverSide;
  }


  get localTotalRecords(): number {
  return Array.isArray(this.data) ? this.data.length : 0;
}

}
